import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { MessageCircle, CalendarCheck, ShieldCheck, BadgeCheck } from "lucide-react";
import { BUSINESS } from "../data/business";
import { track } from "../analytics";

const KEYWORDS = [
    "MEI", "Simples Nacional", "Lucro Presumido", "Lucro Real",
    "BPO Financeiro", "Recuperação de Créditos", "Regularização de Empresas",
    "ERP de Gestão", "Reforma Tributária",
];

export const Hero = () => {
    return (
        <section id="top" data-testid="hero-section" className="relative bg-[#F8FAFC] overflow-hidden">
            <div className="absolute inset-0 dot-grid opacity-60 pointer-events-none" aria-hidden="true" />
            <div className="absolute -top-32 -right-32 w-[520px] h-[520px] rounded-full gold-glow animate-drift pointer-events-none" aria-hidden="true" />
            <div className="absolute -bottom-40 -left-40 w-[420px] h-[420px] rounded-full gold-glow animate-drift-slow pointer-events-none" aria-hidden="true" />
            <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-20 lg:pt-28 lg:pb-32">
                <div className="max-w-3xl mx-auto text-center">
                    <div>
                        <p className="eyebrow animate-fade-up text-xs font-bold uppercase tracking-[0.2em] text-blue-900 mb-5" data-testid="hero-eyebrow">
                            Contabilidade em São Paulo · Atendimento em todo o Brasil
                        </p>
                        <h1 className="animate-fade-up delay-100 text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-slate-900 leading-[1.05]" data-testid="hero-headline">
                            Sua empresa em dia com o fisco,{" "}
                            <span className="text-gold">pagando só o imposto justo.</span>
                        </h1>
                        <p className="animate-fade-up delay-200 mt-6 text-base sm:text-lg text-slate-600 leading-relaxed max-w-xl mx-auto" data-testid="hero-subheadline">
                            Na WBS você fala direto com o contador — sem fila, sem intermediário.
                            Do MEI ao Lucro Real, com mensalidade justa e sem surpresas.
                        </p>
                        <div className="animate-fade-up delay-300 mt-9 flex flex-col sm:flex-row justify-center gap-4">
                            <Button asChild size="lg" className="btn-shine rounded-lg bg-[#25D366] hover:bg-[#1fb857] text-white font-bold transition-transform duration-200 hover:-translate-y-1 shadow-sm hover:shadow-lg">
                                <a href={`${BUSINESS.whatsapp}?text=${encodeURIComponent("Olá! Vim pelo site e quero um orçamento de contabilidade.")}`} target="_blank" rel="noopener noreferrer" data-testid="hero-whatsapp-button" onClick={() => track("interaction", { label: "whatsapp", path: "/" })}>
                                    <MessageCircle className="w-5 h-5 mr-2" />
                                    Pedir orçamento no WhatsApp
                                </a>
                            </Button>
                            <Button asChild size="lg" variant="outline" className="btn-shine rounded-lg border-slate-300 text-slate-800 font-bold hover:border-blue-900 hover:text-blue-900 transition-transform duration-200 hover:-translate-y-1">
                                <Link to="/contato" data-testid="hero-diagnosis-button" onClick={() => track("interaction", { label: "diagnosis", path: "/" })}>
                                    <CalendarCheck className="w-5 h-5 mr-2" />
                                    Agendar diagnóstico gratuito
                                </Link>
                            </Button>
                        </div>
                        <div className="animate-fade-up delay-400 mt-10 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-slate-500" data-testid="hero-trust-row">
                            <span className="flex items-center gap-2">
                                <BadgeCheck className="w-4 h-4 text-blue-900" />
                                {BUSINESS.crc}
                            </span>
                            <span className="flex items-center gap-2">
                                <ShieldCheck className="w-4 h-4 text-blue-900" />
                                Especialistas em redução legal de impostos
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="relative z-10 border-t border-slate-200/80 bg-white/60 backdrop-blur-md" data-testid="hero-marquee">
                <div className="overflow-hidden py-4">
                    <div className="flex w-max animate-marquee items-center gap-10 text-xs font-bold uppercase tracking-[0.22em] text-slate-500">
                        {[...KEYWORDS, ...KEYWORDS].map((keyword, i) => (
                            <span key={i} className="flex items-center gap-10 whitespace-nowrap">
                                <span>{keyword}</span>
                                <span className="w-1.5 h-1.5 rounded-full bg-amber-500" />
                            </span>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};
